export class AddOrEditCategoryModel {
  public id: string;
  public name: string;
  public description: string;
  public companyId: string;
  public languageId: string;
  public pictureURL: string;
}
